import React from "react";
import InputData from "./InputData";
import PreviewData from "./PreviewData";

export default function MainBody() {
  return (
    <section>
      <InputData />
      <PreviewData />
    </section>
  );
}
